<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                    <div class="card">
                        <div class="card-header">
                            <div class="row mb-3">
                                <h4 style="margin-right: 5px" class="float-start">{{ $t("cml_billing_detail_handling_vas") }}</h4>
                            </div>
                            <div class="card-body">
                                <div class="row mb-3">
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('idBillingDetail')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="idBillingDetail"
                                        :placeholder="$t('idBillingDetail')"
                                        v-model="forms.idBillingDetail"
                                        disabled
                                        />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('idBillingHeader')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="idBillingHeader"
                                        :placeholder="$t('idBillingHeader')"
                                        v-model="forms.idBillingHeader"
                                        disabled
                                        />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('SAPMaterialCode')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="SAPMaterialCode"
                                        :placeholder="$t('SAPMaterialCode')"
                                        v-model="forms.SAPMaterialCode"
                                        disabled
                                        />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('SAPDivision')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="SAPDivision"
                                        :placeholder="$t('SAPDivision')"
                                        v-model="forms.SAPDivision"
                                        disabled
                                        />
                                    </div>
                                </div>   
                                <div class="row mb-3">
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('chargeCategory_txt')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="chargeCategory"
                                        :placeholder="$t('chargeCategory_txt')"
                                        v-model="forms.chargeCategory"
                                        disabled
                                        />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('chargeType_txt')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="chargeType"
                                        :placeholder="$t('chargeType_txt')"
                                        v-model="forms.chargeType"
                                        disabled
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">{{$t('rateBaseDesc_txt')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="rateBaseDesc"
                                        :placeholder="$t('rateBaseDesc_txt')"
                                        v-model="forms.rateBaseDesc"
                                        disabled
                                        />
                                    </div>
                                </div>    
                                <div class="row mb-3">
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('qtyCharge')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="qtyCharge"
                                        :placeholder="$t('qtyCharge')"
                                        v-model="forms.qtyCharge"
                                        disabled
                                        />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('rate')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="rate"
                                        :placeholder="$t('rate')"
                                        v-model="forms.rate"
                                        disabled
                                        />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('amountCategory')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="amountCategory"
                                        :placeholder="$t('amountCategory')"
                                        v-model="forms.amountCategory"
                                        disabled
                                        />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">{{$t('remarks_txt')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="remark"
                                        :placeholder="$t('remarks_txt')"
                                        v-model="forms.remark"
                                        disabled
                                        />
                                    </div>
                                </div>  
                            </div>
                            <button
                            v-if="permision_role.method_read"
                            class="btn btn-success float-end btn-xs"
                            style="margin-right: 5px"
                            @click.prevent="downloadData()"
                            >
                            <span class="mdi mdi-download h4"></span>
                            {{ $t("downloadData") }} .xlsx
                            </button>
                            <button
                            class="
                            btn btn-primary
                            text-light
                            fw-bolder
                            btn-icon-text
                            "
                            @click="backForm"
                            type="button"
                        >
                            <i class="link-icon mdi mdi-arrow-left"></i>
                            {{ $t("backMess") }}
                            </button>
                        </div>
                        <div class="card-body" v-if="this.formsHeader.status === 'COMPLETED'">
                            <vue-good-table
                            title="list-billing-cml-billing-detail-handling-vas"
                            ref="list-billing-cml-billing-detail-handling-vas"
                            :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                            mode="remote"
                            @on-selected-rows-change="selectionChanged"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            :totalRows="totalRecords"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :pagination-options="{
                                enabled: true,
                                perPageDropdown: [10, 50, 100, 1000, 10000],
                                dropdownAllowAll: false,
                            }"
                            :rows="rows"
                            :columns="columns"
                            >
                                <div slot="table-actions">
                                    {{ $t("no_select_data") }}
                                </div>
                                <div slot="selected-row-actions">
                                    <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="selectionChangeStatus"> <i
                                        class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                    <button class="btn btn-success btn-xs" @click="removeSelections"><i class="mdi mdi-close"></i> {{
                                        $t("unselect_data_txt")
                                    }} </button>
                                </div>
                                <template slot="column-filter" slot-scope="{ column }">
                                    <span v-if="column.filterOptions.customFilter">
                                        <span v-if="column.field =='receiveDate'">
                                            <date-range-picker style="width:100%" @update="receiveDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="receiveDate" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                            <div slot="header" slot-scope="header" class="slot">
                                                <a @click="clearreceiveDateChange()" class="float-end" style="margin-right: 5px;color:red;">Clear Calendar</a> <span v-if="header.in_selection"> - in selection</span>
                                                <br>
                                            </div>
                                            </date-range-picker>
                                        </span>
                                    </span>
                                </template>
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'actions'">

                                        <a href="#" v-if="permision_role.method_update && props.row.status === 'BILL'" title="NOT BILL" @click.prevent=" changeStatusData(props.index, props.row , 'NOT BILL')">
                                            <button class="btn btn-danger btn-xs">NOT BILL</button>
                                        </a>
                                        <a href="#" v-else @click.prevent="changeStatusData(props.index, props.row, 'BILL')">
                                            <button class="btn btn-primary btn-xs">BILL</button>
                                        </a>
                                    
                                        
                                    </span>
                                    <span v-else-if="props.column.field == 'amount'">
                                    {{toCurrency(props.row.amount)}}
                                    </span>
                                    <span v-else-if="props.column.field == 'rate'">
                                        {{toCurrency(props.row.rate)}}
                                    </span>
                                    <span v-else-if="props.column.field == 'status'">
                                        <span v-if="props.row.status == 'BILL'" class="badge bg-primary"><h5>{{props.row.status}}</h5></span>
                                        <span v-else class="badge bg-danger"><h5>{{props.row.status}}</h5></span>
                                    </span>
                                    <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                    </span>
                                </template>

                            </vue-good-table>
                        </div>
                        <div class="card-body" v-else>
                            <vue-good-table
                            title="list-billing-cml-billing-detail-handling-vas"
                            ref="list-billing-cml-billing-detail-handling-vas"
                            mode="remote"
                            @on-selected-rows-change="selectionChanged"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            :totalRows="totalRecords"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :pagination-options="{
                                enabled: true,
                                perPageDropdown: [10, 50, 100, 1000, 10000],
                                dropdownAllowAll: false,
                            }"
                            :rows="rows"
                            :columns="columns"
                            >
                                <div slot="table-actions">
                                    {{ $t("no_select_data") }}
                                </div>
                                <template slot="column-filter" slot-scope="{ column }">
                                    <span v-if="column.filterOptions.customFilter">
                                        <span v-if="column.field =='receiveDate'">
                                            <date-range-picker style="width:100%" @update="receiveDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="receiveDate" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                            <div slot="header" slot-scope="header" class="slot">
                                                <a @click="clearreceiveDateChange()" class="float-end" style="margin-right: 5px;color:red;">Clear Calendar</a> <span v-if="header.in_selection"> - in selection</span>
                                                <br>
                                            </div>
                                            </date-range-picker>
                                        </span>
                                    </span>
                                </template>
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'actions'">
                                        -
                                    </span>
                                    <span v-else-if="props.column.field == 'amount'">
                                        {{toCurrency(props.row.amount)}}
                                    </span>
                                    <span v-else-if="props.column.field == 'rate'">
                                        {{toCurrency(props.row.rate)}}
                                    </span>
                                    <span v-else-if="props.column.field == 'status'">
                                        <span v-if="props.row.status == 'BILL'" class="badge bg-primary"><h5>{{props.row.status}}</h5></span>
                                        <span v-else class="badge bg-danger"><h5>{{props.row.status}}</h5></span>
                                    </span>
                                    <span v-else>
                                        {{ props.formattedRow[props.column.field] }}
                                    </span>
                                </template>

                            </vue-good-table>
                        </div>
                    </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  
<script>
    import navbarComponent from "@/components/_partials/_navbar";
    import footerComponent from "@/components/_partials/_footer";
    import DateRangePicker from 'vue2-daterange-picker';
  
    export default {
        name: "CmlBillingDetailVas",
        components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
            DateRangePicker,
        },
        data() {
        return {
                opens:"center",
                locale:{
                    format:"yyyy-mm-dd",
                
                },
                receiveDate: {
                    startDate: null,
                    endDate: null
                },
                endOvertime:{
                    startDate: null,
                    endDate: null
                },
                highlighted:{

                    dates: [ // Highlight an array of dates
                        new Date(),
                    ],

                },
                maxToasts: 100,
                position: "up right",
                closeBtn: true,
                isLoading: false,
                errors: [],
                permision_role:[],
                langs: ["id", "en"],
                detailUser: [],
                idBillingHeader:[],
                detailDivisi: [],
                totalRecords: 0,
                receiveDateFrom:"",
                firstBilingDate:"",
                receiveDateTo:"",
                endOvertimeFrom:"",
                endOvertimeTo:"",
                serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
                },
                columns: [
                    {
                        label: this.$t("idDetailVAS"),
                        field: "idDetailVAS",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("idDetailVAS"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    {
                        label: this.$t("statusTxt"),
                        field: "status",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("statusTxt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: ['BILL','NOT BILL'], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    {
                        label: this.$t("docNo"),
                        field: "docNo",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("docNo"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
        
                    {
                        label: this.$t("docType"),
                        field: "docType",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("docType"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    {
                        label: this.$t("receiveDate"),
                        field: "receiveDate",
                        width: '150px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: true,
                        placeholder: this.$t("receiveDate"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
        
                    
        
                    {
                        label: this.$t("sku_txt"),
                        field: "sku",
                        width: '150px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("sku_txt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    {
                        label: this.$t("qty_txt"),
                        field: "qty",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },    
                       

                        

                    {
                        label: this.$t("rate_txt"),
                        field: "rate",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("amount_txt"),
                        field: "amount",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },   
                    {
                        label: this.$t("action_txt"),
                        field: "actions",
                        width: '100px',
                        thClass: 'text-center',
                        sortable: false,
                        filterOptions: {
                            customFilter: false,
                            enabled: false, 
                        },
                    },
                    {
                        label: this.$t("vasType"),
                        field: "vasType",
                        width: '150px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("vasType"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    {
                        label: this.$t("uom"),
                        field: "uom",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("uom"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
        
                    
        
                    {
                        label: this.$t("docLineNo"),
                        field: "docLineNo",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("docLineNo"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },

                    
                  
                    
                        

                    
                            
                    {
                        label: this.$t("editwho"),
                        field: "editwho",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("editwho"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    
                    
                ],
                rows: [],
                rowsSelection:[],
                idCodeLkupsSelections:[],
                forms: {remark: "", rateBaseDesc: "", idBillingDetail: "",  idBillingHeader:"",  chargeCategory:"", chargeType:"", SAPMaterialCode:"", SAPDivision:"",  amountCategory:"" , addwho:"", editwho:"",  qtyCharge:"", rate:""},
                formsHeader: {idBillingHeader: "",  tariffId:"",  customerId:"", warehouseId:"", transactionToDate:"", transactionFromDate:"",  status:"" , amount:"", idRateHeader:"",  transactionDate:"", addwho:"",  editwho:"", adddate:"",  editdate:""},
                
            };
        },
        watch: {},
        methods: {

            changeStatusData(index, row , statusNya) {
                this.$swal({
                    title: this.$t("areYouSure"),
                    text: this.$t("yourData"),
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes!",
                }).then((result) => {
                    if (result.value) {
                    var formData = {
                        idBillingHeader: this.formsHeader.idBillingHeader,
                        idBillingDetail: this.forms.idBillingDetail,
                        idDetailVASs: [row.idDetailVAS],
                        status: statusNya,
                    };
                    const baseURI =
                        this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-vas-charge-update-status";
                    this.$http
                        .post(baseURI, formData,{ timeout: 60000 })
                        .then((response) => {
                        this.loading();
                        if (response.data.status === 200) {
                            this.success(response.data.datas.messages);
                            this.loadItems();

                        } else {
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }
                        }).catch((error) => {
                        this.loading();
                        
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

                        });
                    }else{
                    this.isLoading = false;
                    }
                });

            },

      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

            selectionChangeStatus(){
                this.$swal({
                    title: this.$t("areYouSure"),
                    text: this.$t("yourDataSend"),
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "BILL",
                    cancelButtonText: 'NOT BILL',
                }).then((result) => {
                    if (result.value) {
                        this.isLoading = true;

                        let formData = {
                            idBillingHeader: this.formsHeader.idBillingHeader,
                            idBillingDetail: this.forms.idBillingDetail,
                            idDetailVASs: this.idCodeLkupsSelections,
                            status: "BILL",
                        };
                        const baseURI =
                            this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-vas-charge-update-status";
                        this.$http
                            .post(baseURI, formData,{ timeout: 60000 })
                            .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.idCodeLkupsSelections = [];
                                this.loadItems();

                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                            }).catch((error) => {
                            this.loading();
                            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

                        });

                    }else{
                            
                        this.isLoading = true;
                        let formData = {
                            idBillingHeader: this.formsHeader.idBillingHeader,
                            idBillingDetail: this.forms.idBillingDetail,
                            idDetailVASs: this.idCodeLkupsSelections,
                            status: "NOT BILL",
                        };
                        const baseURI =
                            this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-vas-charge-update-status";
                        this.$http
                            .post(baseURI, formData,{ timeout: 60000 })
                            .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.idCodeLkupsSelections = [];
                                this.loadItems();

                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                            }).catch((error) => {
                            this.loading();
                                    
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
                        });


                    }
                });

            },

            removeSelections() {
                this.idCodeLkupsSelections = [];
                this.$refs['list-billing-cml-billing-detail-handling-vas'].unselectAllInternal()
            },

            selectionChanged(ev) {

                this.rowsSelection = [];
                this.idCodeLkupsSelections  = [];
                this.rowsSelection = ev.selectedRows;

                this.rowsSelection.forEach((item) => {
                    this.idCodeLkupsSelections.push(item.idDetailVAS);

                });
 

            },
            
            endOvertimeChange(){

                if(this.endOvertime.startDate && this.endOvertime.endDate){
                    this.endOvertimeFrom=this.$moment(String(this.endOvertime.startDate)).format('YYYY-MM-DD');
                    this.endOvertimeTo=this.$moment(String(this.endOvertime.endDate)).format('YYYY-MM-DD');
                    this.loadItems()
                }

            },

            clearendOvertimeChange(){
                this.endOvertime={
                    startDate: null,
                    endDate: null
                };
                this.endOvertimeFrom = ""
                this.endOvertimeTo = ""
                this.loadItems()
            },

            receiveDateChange(){

                if(this.receiveDate.startDate && this.receiveDate.endDate){
                    this.receiveDateFrom=this.$moment(String(this.receiveDate.startDate)).format('YYYY-MM-DD');
                    this.receiveDateTo=this.$moment(String(this.receiveDate.endDate)).format('YYYY-MM-DD');
                    this.loadItems()
                }

            },

            clearreceiveDateChange(){
                this.receiveDate={
                    startDate: null,
                    endDate: null
                };
                this.receiveDateFrom = ""
                this.receiveDateTo = ""
                this.loadItems()
            },

            backForm() {
                var params = this.$onRandom(this.$route.params.idBillingHeader);
                window.location.href = "/billing-cml/billing/header/detail/"+params;
            },

            toCurrency (value) {
                if (typeof value !== "number") {
                    return value;
                }
                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'IDR'
                });
                return formatter.format(value);
            },
 
    
            downloadData() {
                var params = this.$onBehind(this.$route.params.idBillingDetail);
                const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-vas-charge/" + params[0];
                this.isLoading = true;
                var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
                var file_name = "download_" + CurrentDate + ".xlsx";
         
                let receiveDateFrom = this.receiveDateFrom
                let receiveDateTo   = this.receiveDateTo
 
                return this.$http
                .get(
                    baseURI +
                    `?idDetailVAS=${this.serverParams.columnFilters.idDetailVAS}&docNo=${this.serverParams.columnFilters.docNo}&docType=${this.serverParams.columnFilters.docType}&receiveDateFrom=${receiveDateFrom}&receiveDateTo=${receiveDateTo}&vasType=${this.serverParams.columnFilters.vasType}&sku=${this.serverParams.columnFilters.sku}&uom=${this.serverParams.columnFilters.uom}&docLineNo=${this.serverParams.columnFilters.docLineNo}&editwho=${this.serverParams.columnFilters.editwho}&status=${this.serverParams.columnFilters.status}&download=download`,
                    {
                    responseType: "blob",
                    }
                )
                .then((response) => {
                    this.isLoading = false;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");
        
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
            },
    
     
    
            // load items is what brings back the rows from server
            loadItems() {

                var params = this.$onBehind(this.$route.params.idBillingDetail);
                const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-vas-charge/" + params[0];
                this.isLoading = true;

                let receiveDateFrom = this.receiveDateFrom
                let receiveDateTo   = this.receiveDateTo

                return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&idDetailVAS=${this.serverParams.columnFilters.idDetailVAS}&docNo=${this.serverParams.columnFilters.docNo}&docType=${this.serverParams.columnFilters.docType}&receiveDateFrom=${receiveDateFrom}&receiveDateTo=${receiveDateTo}&vasType=${this.serverParams.columnFilters.vasType}&sku=${this.serverParams.columnFilters.sku}&uom=${this.serverParams.columnFilters.uom}&docLineNo=${this.serverParams.columnFilters.docLineNo}&editwho=${this.serverParams.columnFilters.editwho}&status=${this.serverParams.columnFilters.status}`,
                    { timeout: 60000 })
                .then((response) => {
                    this.isLoading = false;
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                }).catch((error) => {
                        this.loading();
                                
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
                    });
            },
        
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
                this.loadItems();
            },
        
            onColumnFilter(params) {
                this.updateParams(params);
            },
    
            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
            },
    
            onSortChange(params) {
                this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
                });
            },
    
            onPerPageChange(params) {
                this.updateParams({ per_page: params.currentPerPage });
            },
    
            resultError(data) {
                var count = Object.keys(data).length;
                for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
                }
            },
    
            success(kata) {
                const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
                });
                Toast.fire({
                icon: "success",
                title: kata,
                });
            },
    
            error(kata) {
                const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
                });
                Toast.fire({
                icon: "error",
                title: kata,
                });
            },
    
            fade(sType) {
                this.isLoading = sType;
            },
        
            loading() {
                this.fade(true);
                setTimeout(() => {
                this.isLoading = false;
                }, 1000); // hide the message after 3 seconds
            },
        
            fetchIt() {
                const userDatas     = this.$getUserInfo();
                this.detailUser     = userDatas.sub;
                // this.permision_role = userDatas.sub.permision_role;
                let rolePermision = [];
                userDatas.sub.permision_role.forEach(function(permision){
                if(permision.permission.controller == 'BillingCmlController'){
                    rolePermision = permision;
                }
                });
        
                if(!rolePermision.method_read){
                this.$router.push("/authorized-error");
                }
                this.permision_role = rolePermision;
        
                this.loadData();
            },


            loadData() {
                this.isLoading = true;

                var params = this.$onBehind(this.$route.params.idBillingDetail);

                const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-detail/" + params[0];
                return this.$http.get(baseURI,{ timeout: 60000 }).then((response) => {
                    
                    this.isLoading = false;
                    this.forms                      = response.data.datas;
                    this.forms.amountCategory       = this.toCurrency(response.data.datas.amountCategory)
                    this.forms.rate                 = this.toCurrency(response.data.datas.rate)
                    this.formsHeader                = response.data.datas.bm_billing_header;
                    
                }).catch(error => {
                    this.isLoading = false;
                            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


                });
            },

    
        },
        events: {},
        created: function () {},
        mounted() {
            this.fetchIt();
            this.loading();
        },
    };

</script>
<style scoped>
  .blur-content{
    filter: blur(5px); 
  }
</style>